document.addEventListener("DOMContentLoaded", function() {
    var ctrlVideo = document.getElementById("video-hero__video");
    var btnPlayPause = document.getElementById("video_play");
    var btnSoundMuted = document.getElementById("video_sound");
    var playIcon =  btnPlayPause.querySelector(".play_icon");
    var pauseIcon = btnPlayPause.querySelector(".pause_icon");
    var muteIcon = btnSoundMuted.querySelector('.volume_down_icon');
    var unmuteIcon = btnSoundMuted.querySelector('.volume_up_icon');
    
    btnPlayPause.addEventListener("click", function() {
        if (ctrlVideo.paused) {
            ctrlVideo.play();
            playIcon.style.display = "none";
            pauseIcon.style.display = "inline";
        } else {
            ctrlVideo.pause();
            playIcon.style.display = "inline";
            pauseIcon.style.display = "none";
        }
    });

    btnSoundMuted.addEventListener("click", function() {
        if (ctrlVideo.muted) {
            ctrlVideo.muted = false;
            muteIcon.style.display = "none";
            unmuteIcon.style.display = "inline";
        } else {
            ctrlVideo.muted = true;
            muteIcon.style.display = "inline";
            unmuteIcon.style.display = "none";
        }
    });
});